import { useCallback, useRef } from 'react';

type ObserveLightNode = ((element: HTMLElement) => () => void) | undefined;

export type LightNodeProps = {
	lightNodeRef: (element: HTMLElement | null) => void;
};

// Only LightSubtree supplies this ref, directly to its root's existing DOM element.
export function useLightNodeRef(observe: ObserveLightNode): (element: HTMLElement | null) => void {
	const cleanup = useRef<(() => void) | undefined>(undefined);
	return useCallback(
		(element) => {
			cleanup.current?.();
			cleanup.current = element ? observe?.(element) : undefined;
		},
		[observe],
	);
}
